
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Settings,
  Users,
  Server,
  FolderTree,
  Globe,
  MessageSquare,
  Calendar,
  CheckCircle,
  Image,
  FileText,
  Bug,
  Info,
  Bell,
  Palette
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarRail,
  SidebarHeader,
} from "@/components/ui/sidebar";

export function AdminSidebar() {
  const location = useLocation();

  const menuItems = [
    {
      title: "Dashboard",
      url: "/admin",
      icon: LayoutDashboard,
      isActive: location.pathname === "/admin"
    },
    {
      title: "Users",
      url: "/admin/users",
      icon: Users,
      isActive: location.pathname.startsWith("/admin/users")
    },
    {
      title: "Services",
      url: "/admin/services",
      icon: Server,
      isActive: location.pathname.startsWith("/admin/services")
    },
    {
      title: "Categories",
      url: "/admin/categories",
      icon: FolderTree,
      isActive: location.pathname.startsWith("/admin/categories")
    },
    {
      title: "Regions",
      url: "/admin/regions",
      icon: Globe,
      isActive: location.pathname.startsWith("/admin/regions")
    },
    {
      title: "Reviews",
      url: "/admin/reviews",
      icon: MessageSquare,
      isActive: location.pathname.startsWith("/admin/reviews")
    },
    {
      title: "Bookings",
      url: "/admin/bookings",
      icon: Calendar,
      isActive: location.pathname === "/admin/bookings"
    },
    {
      title: "Completed",
      url: "/admin/completed",
      icon: CheckCircle,
      isActive: location.pathname === "/admin/completed"
    },
    {
      title: "Brand",
      url: "/admin/brand",
      icon: Palette,
      isActive: location.pathname.startsWith("/admin/brand")
    },
    {
      title: "Media",
      url: "/admin/media",
      icon: Image,
      isActive: location.pathname.startsWith("/admin/media")
    },
    {
      title: "Terms",
      url: "/admin/terms",
      icon: FileText,
      isActive: location.pathname.startsWith("/admin/terms")
    },
    {
      title: "About Us",
      url: "/admin/about-us",
      icon: Info,
      isActive: location.pathname.startsWith("/admin/about-us")
    },
    {
      title: "Settings",
      url: "/admin/settings",
      icon: Settings,
      isActive: location.pathname.startsWith("/admin/settings")
    },
    {
      title: "Testing",
      url: "/admin/testing",
      icon: Bug,
      isActive: location.pathname.startsWith("/admin/testing"),
      className: "text-red-600"
    }
  ];

  return (
    <Sidebar collapsible="icon" className="bg-white border-r">
      <SidebarHeader className="h-16 bg-white border-b" />
      <SidebarContent className="bg-white pt-4">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton 
                    asChild 
                    isActive={item.isActive}
                    tooltip={item.title}
                    className="bg-white hover:bg-gray-100 data-[active=true]:bg-blue-50 data-[active=true]:text-blue-600"
                  >
                    <Link to={item.url} className={item.className}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
